module.exports = __webpack_public_path__ + "img/content6-11.663f91fe.webp";